export default __webpack_public_path__ + "static/media/kitchen4-afterA-2048w.91ee84a6.avif";